import { useLPSuspenseQuery } from '../lib/hooks/useLPQuery';

export function useAvatarQuery() {
  return useLPSuspenseQuery<Avatar>(['avatar'], '/me/avatar');
}
type Avatar = {
  id: string;
  avatar: string;
};
